import React from 'react';

/**
 * Route placeholder for /landing (and BaseLine /welcome).
 * Real Landing UI is kept mounted by App to avoid remount on back navigation.
 */
export default function PersistentLandingSlot() {
  return null;
}
